import { WebsiteModule } from '@/interfaces/module.interface';
import { ApiQueryParams, apiRequest } from '../Api';
import { buildFilterParams, type FilterParam } from '@/hooks/apis/utils';

export interface GetWebsiteModuleListRequest extends ApiQueryParams {
  page?: number;
  page_limit?: number;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
  search?: string;
  // Filtering parameters: fk[index][field] and fk[index][value]
  // Example: [{ field: 'website_project_id', value: '123' }] becomes
  // fk[0][field]=project_id&fk[0][value]=123
  // Note: Field names should be database field names (e.g., 'project_id', not 'projectId')
  filters?: FilterParam[];
}

export interface GetWebsiteModuleListResponse {
  success: boolean;
  message: string;
  data: WebsiteModule[];
  cached: boolean;
  total: number;
  page_items: number;
  last_page: number;
  current_page: number;
  items_per_page: number;
}

export const listWebsiteModules = (params: GetWebsiteModuleListRequest) => {
  // Extract filters and convert to fk[index][field] format
  const { filters, ...restParams } = params;
  const filterParams = buildFilterParams(filters);
  
  // Merge standard params with filter params
  // Note: filterParams contains fk[index][field] keys which are valid query params
  // Standard query params (project_id, etc.) come from env vars for API routing
  // Filter params (fk[index][field]) are for filtering by parent entity fields
  const finalParams = {
    ...restParams,
    ...filterParams,
  };

  return apiRequest<void, GetWebsiteModuleListResponse>({
    url: '/entities/list',
    scope: 'module',
    method: 'GET',
    params: finalParams,
  });
};

